import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';
import { OptionValues } from '../../utils/reshopping_alert';

export const ReshoppingAlertDetailsStep: Step = {
  id: 'reshoppingalertdetails',
  pathname: '/reshoppingalertdetails',
  canShow: (appData: AppData): boolean => {
    const reshoppingAlertAnswer0 = appData.reshoppingAlertAnswer0;
    if (!reshoppingAlertAnswer0) {
      return false;
    }

    return (
      OptionValues.BEFORE_RENEWAL === reshoppingAlertAnswer0 || OptionValues.LET_ME_CHOOSE === reshoppingAlertAnswer0
    );
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !!appData.reshoppingAlertAnswer1,
  category: () => StepCategory.Other,
};
